import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import {
  PresaleVerifyPage,
  presaleVerifySearchSchema,
} from "@/features/presale";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  ...presaleVerifySearchSchema.shape,
  ...maskSearchFragment,
});

export const Route = createFileRoute("/(member)/(public)/presale/verify")({
  component: RouteComponent,
  validateSearch: searchSchema,
});

function RouteComponent() {
  return <PresaleVerifyPage search={Route.useSearch()} />;
}
